
//
const sessionStorage = require('../utils/sessionStorage.js');

//
document.querySelectorAll('.advert').forEach((advert) => {

    //check to see if we could be on a mobile type screen (super janky) - if so - do not show the advert
    if (window.innerWidth < advert.dataset.visibleFrom) {
        return;
    }

    //
    if (sessionStorage.get(advert.dataset.advertName) == 'shown') {
        return;
    }

    //display the advert after n seconds (default to 10)
    if (advert.dataset.state == 'hidden') {
        window.setTimeout(() => {
            advert.setAttribute('data-state', 'maximised');
            sessionStorage.set(advert.dataset.advertName, 'shown');
        }, advert.dataset?.delay ?? 10000);
    }

    //
    const advertClose = advert.querySelector('button[data-action="close"]');
    if (advertClose !== null) {
        advertClose.addEventListener('click', (event) => {
            advert.parentElement.removeChild(advert);
            navigator.sendBeacon('/api/advert-tracker', JSON.stringify({ 'advert': advert.dataset.advertName, 'event': 'closed' }));
        });
    }

    //
    const advertMinimise = advert.querySelector('button[data-action="minimise"]');
    if (advertMinimise !== null) {
        advertMinimise.addEventListener('click', (event) => {
            advert.setAttribute('data-state', 'minimised');
        });
    }

    //
    const advertMaximise = advert.querySelector('button[data-action="maximise"]');
    if (advertMaximise !== null) {
        advertMaximise.addEventListener('click', (event) => {
            advert.setAttribute('data-state', 'maximised');
        });
    }

});